<template>
  <page>
    <span slot="page-title">About</span>
    <p>The 2020 U.S. Presidential, Senate, and House forecasts were developed and are maintained by DecisionDeskHQ, in partnership with the 0ptimus Analytics Data Science team.</p>
    <p>The model on the website is the public version and includes all reputable and available public polling. 0ptimus Analytics advises private clients on legislative risk and in those instances a private version of the models are utilized that contains client specific datasets, including private polling.</p>
    <p>The data were retrieved from public sources where appropriate and the privately sourced data is derived from 0ptimus's access to political, economic and demographic data sets at the national, state and district level. More information can be found on our <a @click="$router.push({ name: 'methodology' })">methodology</a> page.</p>
    <p>Think you have a smart angle we're missing? Just like this stuff in general? Want to come work at a cool place? Reach out and tell us.</p>
    <p>
      <span>Press: <a href="mailto:press@0ptimus.com">press@0ptimus.com</a></span>
      <br>
      <span>General Inquiries: <a href="mailto:Elections@0ptimus.com">Elections@0ptimus.com</a></span>
      <br>
      <span>Twitter:
        <a href="https://twitter.com/DecisionDeskHQ" target="_blank">@DecisionDeskHQ</a>,
        <a href="https://twitter.com/be0ptimus">@Be0ptimus</a>,
        <a href="https://twitter.com/0ptimusPredicts">@0ptimusPredicts</a>
      </span>
      <br>
    </p>
  </page>
</template>

<script>
import { Page } from '@/components'

const name = 'about'

const components = {
  Page
}

export default {
  name,
  components,
  metaInfo: {
    title: 'About',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'About'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'About'
      }, {
        vmid: 'description',
        name: 'description',
        content: 'The Øptimus forecasting model was created and maintained by Scott Tranter (partner) of Øptimus Consulting and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Øptimus data science team.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: 'The Øptimus forecasting model was created and maintained by Scott Tranter (partner) of Øptimus Consulting and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Øptimus data science team.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: 'The Øptimus forecasting model was created and maintained by Scott Tranter (partner) of Øptimus Consulting and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Øptimus data science team.'
      }
    ]
  }
}
</script>
